import type { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';
import Table from '../../data-display/Table';

interface ListCardCellProps extends ComponentPropsWithoutRef<typeof Table.Td> {
    withDarkBackground?: boolean;
    rounded?: boolean;
}

export default function ListCardCell({ className, withDarkBackground = false, rounded = true, ...props }: ListCardCellProps) {
    void rounded; // mantido na API; a célula agora é reta
    return (
        <Table.Td
            {...props}
            className={twMerge([
                // Rodada 2 (28/10): célula plana com filete embaixo (sem sombra nem canto).
                'bg-white border-b border-neutro-200 transition-colors duration-100 dark:border-white/10',
                withDarkBackground ? 'dark:bg-darkmode-600' : undefined,
                className,
            ])}
        />
    );
}
